export class Instancesmanager {
    constructor() {
        this.instances = {};
    }

    getInstance(key) {
        let instance = this.instances[key];
        if (instance === undefined) {
            instance = null;
        }
        return instance;
    }

    addInstance(key, instance) {
        if (this.instances[key]) {
            console.warn('Модальное окно с таким id уже создано.');
            return;
        }
        this.instances[key] = instance;
    }

    static removeInstance(key) {
        if (!this.instances[key]) {
            return;
        }

        delete this.instances[key];
    }
}